import { ORGANIZATIONS_QUERY_KEY } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { organizationApi } from "@/api/services";

export const useGetOrganizations = (enabled = true) => {
  return useQuery({
    queryKey: [ORGANIZATIONS_QUERY_KEY],
    queryFn: () => organizationApi.getOrganizations(),
    enabled,
    // NOTE: Overrides the global `refetchOnWindowFocus: false` default for this
    // query only. The WS push in use-notification-socket.ts is the primary way
    // an ownership change reaches the affected user, but it can miss: emit()
    // skips users who muted the ORGANIZATIONS notification category, and a push
    // sent while the socket was down is never replayed. Refetching when the tab
    // regains focus closes both gaps at the moment the user actually looks at
    // the page, without the steady-state cost of an interval (NSAI-3616).
    refetchOnWindowFocus: true,
  });
};
